"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidMediaFileTypesRegExp = exports.ValidMediaFileTypes = exports.PasswordConfig = exports.PermissionsInheritToParentGroups = exports.PermissionsInheritToChildGroups = void 0;
const helpers_1 = require("./helpers");
const types_1 = require("./types");
exports.PermissionsInheritToChildGroups = {
    [helpers_1.HasuraRoles.ADMIN_USER]: [],
    [helpers_1.HasuraRoles.LIFF_USER]: [],
    [helpers_1.HasuraRoles.SPACECLOUD_ADMIN]: [
        types_1.TablePermissions.USER_GROUP_SELECT,
        types_1.TablePermissions.USER_GROUP_INSERT,
        types_1.TablePermissions.USER_GROUP_UPDATE,
        types_1.TablePermissions.USER_GROUP_DELETE,
        types_1.TablePermissions.USER_SELECT,
        types_1.TablePermissions.USER_INSERT,
        types_1.TablePermissions.USER_UPDATE,
        types_1.TablePermissions.USER_DELETE,
        types_1.TablePermissions.USER_AVATAR_MEDIA_SELECT,
        types_1.TablePermissions.USER_AVATAR_MEDIA_INSERT,
        types_1.TablePermissions.USER_AVATAR_MEDIA_UPDATE,
        types_1.TablePermissions.USER_AVATAR_MEDIA_DELETE,
        types_1.TablePermissions.INVITE_INSERT,
        types_1.TablePermissions.INVITE_SELECT,
        types_1.TablePermissions.INVITE_UPDATE,
        types_1.TablePermissions.INVITE_DELETE,
        types_1.TablePermissions.ASSET_SELECT,
        types_1.TablePermissions.ASSET_INSERT,
        types_1.TablePermissions.ASSET_UPDATE,
        types_1.TablePermissions.ASSET_DELETE,
        types_1.TablePermissions.ASSET_GROUP_SELECT,
        types_1.TablePermissions.ASSET_GROUP_INSERT,
        types_1.TablePermissions.ASSET_GROUP_UPDATE,
        types_1.TablePermissions.ASSET_GROUP_DELETE,
        types_1.TablePermissions.ASSET_CLASS_SELECT,
        types_1.TablePermissions.ASSET_CLASS_INSERT,
        types_1.TablePermissions.ASSET_CLASS_UPDATE,
        types_1.TablePermissions.ASSET_CLASS_DELETE,
        types_1.TablePermissions.ASSET_BOOKING_SELECT,
        types_1.TablePermissions.ASSET_BOOKING_INSERT,
        types_1.TablePermissions.ASSET_BOOKING_UPDATE,
        types_1.TablePermissions.ASSET_BOOKING_DELETE,
        types_1.TablePermissions.GROUP_USER_ROLE_SELECT,
        types_1.TablePermissions.GROUP_USER_ROLE_INSERT,
        types_1.TablePermissions.GROUP_USER_ROLE_UPDATE,
        types_1.TablePermissions.GROUP_USER_ROLE_DELETE,
        types_1.ApplicationPermissions.ADMIN_ACCESS,
    ],
    [helpers_1.HasuraRoles.SPACECLOUD_USER]: [
        types_1.TablePermissions.ASSET_GROUP_SELECT,
        types_1.TablePermissions.ASSET_CLASS_SELECT,
        types_1.TablePermissions.ASSET_SELECT,
    ],
    [helpers_1.HasuraRoles.ANONYMOUS_USER]: [],
    [helpers_1.HasuraRoles.SPACECLOUD_TRAFFIC_IOT]: [],
};
exports.PermissionsInheritToParentGroups = {
    [helpers_1.HasuraRoles.ADMIN_USER]: [],
    [helpers_1.HasuraRoles.LIFF_USER]: [
        types_1.TablePermissions.ASSET_GROUP_SELECT,
        types_1.TablePermissions.ASSET_CLASS_SELECT,
        types_1.TablePermissions.ASSET_SELECT,
    ],
    [helpers_1.HasuraRoles.SPACECLOUD_ADMIN]: [],
    [helpers_1.HasuraRoles.SPACECLOUD_USER]: [
        types_1.TablePermissions.ASSET_GROUP_SELECT,
        types_1.TablePermissions.ASSET_CLASS_SELECT,
        types_1.TablePermissions.ASSET_SELECT,
    ],
    [helpers_1.HasuraRoles.ANONYMOUS_USER]: [],
    [helpers_1.HasuraRoles.SPACECLOUD_TRAFFIC_IOT]: [],
};
exports.PasswordConfig = {
    length: 50,
    uppercase: true,
    numbers: true,
    symbols: true,
    lowercase: true,
    strict: true,
};
exports.ValidMediaFileTypes = ["image/jpeg", "image/png"];
exports.ValidMediaFileTypesRegExp = /^image\/(jpeg|png)$/;
//# sourceMappingURL=config.js.map